<template>
  <div class="MarketInfoHome pt7" v-title data-title="行情首页">
    <div class="row align-items-center justify-content-around stock-btn">
      <van-button v-for="st in stockBtns" :key="st.name" type="info" @click="go(st.path)">{{st.name}}</van-button>
    </div>
    <div><van-button type="info" plain @click="back" style="width: 60%;">返 回</van-button></div>
  </div>
</template>

<script>
import Vue from 'vue';
// import storage from '../../uitls/cacheUtil';

export default Vue.extend({
  name: 'MarketInfoHome',
  components: {},
  data() {
    return {
      stockBtns: [
        { name: '行情类型', path: '/market/type/list' },
        // { name: '行情地区', path: '/market/region/list' },
        // { name: '行情行话', path: '/market/category/edit' },
        { name: '行情价格', path: '/market/info/edit' },
      ],
    };
  },
  methods: {
    go(path) {
      if (!path) {
        return;
      }
      this.$router.push(path);
    },
    back() {
      this.$router.push('/home');
    },
  },
  created() {
    // const type = storage.local.get('type');
    // if (type === 1) {
    //   return;
    // }
    // this.$router.push('/');
  },
});
</script>
<style scoped>
.MarketInfoHome {
  min-height: 100vh;
}
.stock-btn {
  height: 60vh;
}
</style>
